import React, { PureComponent } from 'react';
import './ProgressDialog.css';
import Modal2 from '../../modals/Modal2';
import t from '../../i18n/I18n';

type Props = {
  isRunningBackground: boolean,
  isCancelAble: boolean,
  onClose: ?func,
  onRunningBackground: ?func,
  onComplate: ?func,
  loaded: ?number,
  message: string
};
export class ProgressDialog extends PureComponent<Props, State> {
  state = {
    modalProps: {},
    showModal: false
  };

  componentDidMount() {
    this.setState({ modalProps: this.getModalProps(), showModal: true });
  }

  getModalProps = () => {
    const { isRunningBackground = true, isCancelAble = true, title = '' } = this.props;
    const props = {
      name: 'ProgressDialog',
      title: title || 'Progress',
      onClose: this.onClose,
      buttons: []
    };
    if (isCancelAble)
      props.buttons.push({
        label: t('CANCEL_LABEL'),
        onClick: this.onCancel,
        type: 'PRIMARY',
        style: { backgroundColor: '#b5b5b5' }
      });
    if (isRunningBackground)
      props.buttons.push({ label: t('RUN_BACKGROUND'), onClick: this.onRunningBackgroundClick, type: 'PRIMARY' });
    return props;
  };

  onCancel = () => {
    this.props.onCancel();
  };

  onClose = () => {
    this.props.onClose();
  };

  onRunningBackgroundClick = () => {
    this.props.onRunningBackground();
  };

  render() {
    const { modalProps, showModal } = this.state;
    const { loaded, type2 } = this.props;
    if (!showModal) return null;
    return (
      <Modal2 {...modalProps}>
        <div className="content">{this.props.message}</div>
        <div>{type2 ? <ProgressBarType2 /> : <ProgressBar loaded={loaded} />}</div>
      </Modal2>
    );
  }
}

type ProgressBarProps = {
  loaded: number
};
const ProgressBar = function(props: ProgressBarProps) {
  let progress = Math.floor(props.loaded) || 0;
  return (
    <div className="loading">
      <div className="progress-bar">
        <div style={{ width: `${progress}%` }} />
      </div>
      <div className="progress-text">{progress}%</div>
    </div>
  );
};

const ProgressBarType2 = function() {
  return (
    <div className="loading">
      <div className="uploadingLoader" />
    </div>
  );
};
